import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_MSG_URL } from "./data";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      data-testid="floating-whatsapp-action-button"
      href={WHATSAPP_MSG_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with swaclean on WhatsApp"
      className="group fixed bottom-5 right-5 z-[60] flex items-center gap-3"
    >
      <span className="pointer-events-none hidden rounded-full bg-slate-900 px-4 py-2 text-xs font-bold text-white opacity-0 shadow-xl transition-all duration-300 group-hover:opacity-100 sm:block">
        Chat with us — replies in minutes
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp text-white shadow-xl shadow-whatsapp/40 transition-transform duration-300 group-hover:scale-110">
        <span className="absolute inset-0 animate-ping rounded-full bg-whatsapp/50 [animation-duration:2.2s]" />
        <MessageCircle className="relative h-6 w-6" />
      </span>
    </motion.a>
  );
}
